const SNAPSHOTS_BASE = "/snapshots";

interface SnapshotCollectionPathInput {
  business_report_id: string;
  id: string;
}

interface SnapshotPathOptions {
  subcollectionId?: string;
  contractFamilyProjection?: boolean;
  supplierContractFolderId?: string;
}

export const buildSnapshotGridPath = (
  businessReportId: string,
  collectionId: string,
  { subcollectionId, contractFamilyProjection, supplierContractFolderId }: SnapshotPathOptions = {},
): string => {
  const base = `${SNAPSHOTS_BASE}/grid/${businessReportId}/${collectionId}/`;
  if (!subcollectionId && !contractFamilyProjection && !supplierContractFolderId) {
    return base;
  }
  const params = new URLSearchParams();
  if (subcollectionId) params.set("subcollection_id", subcollectionId);
  if (contractFamilyProjection) params.set("contractFamilyProjection", "true");
  if (supplierContractFolderId) params.set("supplierContractFolderId", supplierContractFolderId);
  return `${base}?${params.toString()}`;
};

export const buildSnapshotCollectionGridPath = (
  collection: SnapshotCollectionPathInput,
  options: SnapshotPathOptions = {},
): string => buildSnapshotGridPath(collection.business_report_id, collection.id, options);

export const buildSnapshotCollectionsPath = (
  businessReportId: string,
  collectionId: string,
  { subcollectionId }: SnapshotPathOptions = {},
): string => {
  const params = new URLSearchParams({
    businessReportId,
    snapshotCollectionId: collectionId,
  });
  if (subcollectionId) {
    params.set("subcollection_id", subcollectionId);
  }
  return `${SNAPSHOTS_BASE}/collections?${params.toString()}`;
};
